export default "__VITE_ASSET__ec34d5af__"